// import React from "react";
// import { CheckCircle } from "lucide-react";

// /**
//  * Certificate UI – matches the shared mock as closely as possible using Tailwind.
//  *
//  * Usage:
//  *   export default function Page() { return <NewformCerti /> }
//  *
//  * Optional: pass a `data` prop to override defaults.
//  */

// const defaultData = {
//   company: {
//     name: "Professional Fire Protection Services",
//     subtitleRight: "CERTIFICATE OF\nINSPECTION",
//     captionRight: "NFPA 25 Compliance",
//   },
//   title: "WATER-BASED FIRE PROTECTION SYSTEM INSPECTION",
//   status: { text: "PASSED - System in Service", color: "text-green-600" },
//   client: {
//     clientName: "Skyline Tower",
//     buildingName: "Skyline Tower",
//     address: "123 Main Street, Metropolis, NY 10001",
//   },
//   details: {
//     inspectionDate: "May 15, 2023",
//     inspectionType: "Annual Inspection",
//     systemType: "Wet Pipe Sprinkler System",
//   },
//   summary:
//     "This is to certify that the above-referenced water-based fire protection system has been inspected in accordance with NFPA 25: Standard for the Inspection, Testing, and Maintenance of Water-Based Fire Protection Systems.",
//   nextDue: "May 15, 2024",
//   deficiencies: [
//     {
//       severity: "Non-Critical Deficiency - Room 302",
//       description: "Sprinkler head in room 302 has minor corrosion",
//       action: "Schedule replacement within 30 days",
//     },
//   ],
//   recommendations:
//     "Recommend quarterly testing of water flow devices and annual internal inspection of check valves.",
//   inspector: {
//     name: "John Smith",
//     certNo: "NICET III-12345",
//   },
//   footer: {
//     note: "This certificate must be maintained in accordance with NFPA 25.",
//     generated: "Document generated on July 17, 2025",
//   },
// };

// export default function NewformCerti({ data = defaultData }) {
//   const d = { ...defaultData, ...data };

//   return (
//     <div className="min-h-screen w-full bg-neutral-50 py-10 print:bg-white print:py-0">
//       <div className="mx-auto w-full max-w-4xl rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 print:shadow-none print:ring-0 print:rounded-none print:p-8">
//         {/* Header */}
//         <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
//           <div>
//             <h1 className="text-2xl font-semibold text-gray-900">
//               {d.company.name}
//             </h1>
//           </div>
//           <div className="text-right">
//             <p className="text-xl font-semibold tracking-wide text-gray-900 uppercase whitespace-pre-line">
//               {d.company.subtitleRight}
//             </p>
//             <p className="text-sm text-gray-500">{d.company.captionRight}</p>
//           </div>
//         </div>

//         <div className="my-4 border-t" />

//         {/* Title */}
//         <div className="text-center">
//           <h2 className="text-lg font-semibold tracking-wide text-gray-900 uppercase">
//             {d.title}
//           </h2>
//           <div className={`mt-2 inline-flex items-center gap-2 text-sm font-semibold ${d.status.color}`}>
//             <CheckCircle className="h-5 w-5" />
//             <span>{d.status.text}</span>
//           </div>
//         </div>

//         {/* Two-column info */}
//         <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
//           <Card title="Client Information">
//             <Field label="Client Name" value={d.client.clientName} />
//             <Field label="Building Name" value={d.client.buildingName} />
//             <Field label="Address" value={d.client.address} />
//           </Card>

//           <Card title="Inspection Details">
//             <Field label="Inspection Date" value={d.details.inspectionDate} />
//             <Field label="Inspection Type" value={d.details.inspectionType} />
//             <Field label="System Type" value={d.details.systemType} />
//           </Card>
//         </div>

//         {/* Summary */}
//         <Section title="Inspection Summary" className="mt-6">
//           <p className="text-gray-700 leading-relaxed">{d.summary}</p>
//           <p className="mt-3 font-semibold text-gray-900">
//             <span className="font-semibold">Next Inspection Due:</span> {d.nextDue}
//           </p>
//         </Section>

//         {/* Deficiencies */}
//         <Section title="Deficiencies Found" className="mt-6">
//           {d.deficiencies.length === 0 ? (
//             <p className="text-gray-600">No deficiencies found.</p>
//           ) : (
//             <ul className="space-y-4">
//               {d.deficiencies.map((def, i) => (
//                 <li
//                   key={i}
//                   className="rounded-xl border p-4 shadow-sm ring-1 ring-black/5"
//                 >
//                   <div className="flex gap-3">
//                     <div className="w-1.5 shrink-0 rounded-full bg-yellow-500" />
//                     <div className="space-y-1">
//                       <p className="font-semibold text-gray-900">{def.severity}</p>
//                       <p className="text-gray-700">{def.description}</p>
//                       <p className="text-gray-700">
//                         <span className="font-semibold">Recommended Action:</span>{" "}
//                         {def.action}
//                       </p>
//                     </div>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </Section>

//         {/* Recommendations */}
//         <Section title="Recommendations" className="mt-6">
//           <p className="text-gray-700">{d.recommendations}</p>
//         </Section>

//         {/* Signatures */}
//         <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
//           <Card title="Inspector Certification">
//             <Field label="Inspector Name" value={d.inspector.name} />
//             <Field label="Certification Number" value={d.inspector.certNo} />
//             <SignatureLine label="Inspector Signature" />
//           </Card>
//           <Card title="Customer Acknowledgment">
//             <p className="text-gray-700">
//               I acknowledge receipt of this inspection report and understand the
//               findings and recommendations.
//             </p>
//             <SignatureLine label="Customer Signature" />
//           </Card>
//         </div>

//         {/* Footer */}
//         <div className="mt-10 space-y-1 text-center">
//           <p className="text-sm text-gray-500">{d.footer.note}</p>
//           <p className="text-xs text-gray-400">{d.footer.generated}</p>
//         </div>

//         {/* Print button (hidden when printing) */}
//         <div className="mt-6 flex justify-end print:hidden">
//           <button
//             onClick={() => window.print()}
//             className="inline-flex items-center rounded-xl border px-4 py-2 text-sm font-medium shadow-sm hover:bg-gray-50"
//           >
//             Print / Save as PDF
//           </button>
//         </div>
//       </div>

//       {/* Inline print tweaks */}
//       <style>{`
//         @media print {
//           @page { margin: 18mm; }
//           .no-print { display: none !important; }
//         }
//       `}</style>
//     </div>
//   );
// }

// function Card({ title, children }) {
//   return (
//     <div className="rounded-2xl border bg-white p-5 shadow-sm ring-1 ring-black/5">
//       {title ? (
//         <h3 className="mb-3 text-lg font-semibold text-gray-900">
//           {title}
//         </h3>
//       ) : null}
//       <div className="space-y-2">{children}</div>
//     </div>
//   );
// }

// function Section({ title, className = "", children }) {
//   return (
//     <div className={`rounded-2xl border bg-white p-5 shadow-sm ring-1 ring-black/5 ${className}`}>
//       {title ? (
//         <h3 className="mb-3 text-lg font-semibold text-gray-900">{title}</h3>
//       ) : null}
//       {children}
//     </div>
//   );
// }

// function Field({ label, value }) {
//   return (
//     <p className="text-gray-700">
//       <span className="font-semibold text-gray-900">{label}: </span>
//       {value}
//     </p>
//   );
// }

// function SignatureLine({ label }) {
//   return (
//     <div className="pt-10">
//       <div className="border-t-2 border-dashed" />
//       <p className="mt-1 text-center text-sm italic text-gray-500">{label}</p>
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import axiosInstance from "../../../../Services/axiosCommon";
import NuDate from "../../../../Components/Utils/NuDate";
import { useToast } from "../../../../Components/Others/ToastServices";

export default function NewformCerti({ isEditing = true, allSubmitted }) {
  const { scheduleViewId } = useParams();
  const toastService = useToast();


  const signOne = useRef(null);
  const signTwo = useRef(null);


  const [formData, setFormData] = useState({
    signature1: null,
    signature2: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [oldSignatures, setOldSignatures] = useState({
    signature1: null,
    signature2: null,
  });
  const [signaturesToRemove, setSignaturesToRemove] = useState({
    signature1: null,
    signature2: null,
  });
  const [newFormDetails, setNewFormDetails] = useState(null);

 
  const getSignatures = () => {
    //   setFormData({ signature1: null, signature2: null });
  // setOldSignatures({ signature1: null, signature2: null });

// setFormData([])

     axiosInstance
      .get(`/schedules/get-signatures/${scheduleViewId}`)
      .then((res) => {
        const responseData = res.data?.data;
        setNewFormDetails(responseData);

        // Save old signatures from API response
        setOldSignatures({
          signature1: responseData?.signature1?.file || null,
          signature2: responseData?.signature2?.file || null,
        });

        // Keep only Files in formData, reset if not
        setFormData((prev) => ({
          signature1: prev.signature1 instanceof File ? prev.signature1 : null,
          signature2: prev.signature2 instanceof File ? prev.signature2 : null,
        }));
//   setFormData({ signature1: null, signature2: null });
  // setOldSignatures({ signature1: null, signature2: null });

 
        //  setFormData([]);
      })
      .catch((err) => {
        console.log("Error fetching signatures", err);
        toastService.open({
          type: "error",
          message: "Error",
          description: "Failed to load signatures.",
        });
      });
  };

  
  const removeSignature = (signatureKey) => {
    setFormData((prev) => ({
      ...prev,
      [signatureKey]: null,
    }));

    
    setSignaturesToRemove((prev) => ({
      ...prev,
      [signatureKey]: oldSignatures[signatureKey],
    }));

   
    setOldSignatures((prev) => ({
      ...prev,
      [signatureKey]: null,
    }));

    
    if (signatureKey === "signature1" && signOne.current) {
      signOne.current.clear();
    } else if (signatureKey === "signature2" && signTwo.current) {
      signTwo.current.clear();
    }
  };

   const saveSignatures = () => {
    setIsSubmitting(true);

    const submitData = new FormData();

       if (formData.signature1 instanceof File) {
      submitData.append("signature1", formData.signature1);
    }
    if (formData.signature2 instanceof File) {
      submitData.append("signature2", formData.signature2);
    }

     const jsonData = {
      oldSign1: signaturesToRemove.signature1 ? "" : oldSignatures.signature1,
      oldSign2: signaturesToRemove.signature2 ? "" : oldSignatures.signature2,
    };

    submitData.append("json_data", JSON.stringify(jsonData));

    axiosInstance
      .put(`/schedules/edit-signatures/${scheduleViewId}`, submitData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        setIsSubmitting(false);
        toastService.open({
          type: "success",
          message: "Success",
          description: "Signatures saved successfully.",
        });

        setSignaturesToRemove({ signature1: null, signature2: null });
        getSignatures();
      })
      .catch((err) => {
        setIsSubmitting(false);
        console.log("Error saving signatures", err);
        toastService.open({
          type: "error",
          message: "Error",
          description: "Failed to save signatures.",
        });
      });
  };

  useEffect(() => {
    getSignatures();
  }, [scheduleViewId]);

  return (
    <div className="min-h-screen w-full bg-neutral-50 py-2 h-[calc(100vh-160px)] print:bg-white print:py-0">
      <div className="mx-auto w-full h-[calc(100vh-170px)] overflow-y-auto rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 print:shadow-none print:ring-0 print:rounded-none print:p-8">
        {/* Header */}
        <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
          <div className="text-center">
            <p className="text-xl font-semibold tracking-wide text-gray-900 uppercase">
              INSPECTION CERTIFICATE
            </p>
            <p className="text-sm text-gray-600 mt-1 text-left">
              {newFormDetails?.certRefNumber || "N/A"}
            </p>
          </div>
        </div>

        <div className="my-4 border-t" />

        {/* Title */}
        <div className="text-center">
          <h2 className="text-lg font-semibold tracking-wide text-gray-900 uppercase">
            {newFormDetails?.inspection?.description || "Inspection"}
          </h2>
          <div
            className={`mt-2 inline-flex items-center gap-2 text-[16px] font-semibold ${
              allSubmitted ? "text-green-600" : "text-orange-500"
            }`}
          >
            {allSubmitted ? "Complete" : "Draft"}
          </div>
        </div>

        {/* Two-column info */}
        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          <Card title="Client Information">
            <Field
              label="Company Name"
              value={newFormDetails?.client?.companyName || "N/A"}
            />
            <Field
              label="Reference"
              value={newFormDetails?.client?.refNumber || "N/A"}
            />
            <Field
              label="Email"
              value={newFormDetails?.client?.email || "N/A"}
            />
            <Field
              label="Phone"
              value={newFormDetails?.client?.phoneWithCC || "N/A"}
            />
            <Field
              label="Address"
              value={`${newFormDetails?.client?.address1 || ""}, ${
                newFormDetails?.client?.address2 || ""
              }`}
            />
            <Field
              label="Street"
              value={newFormDetails?.client?.streetName || "N/A"}
            />
            <Field
              label="City"
              value={newFormDetails?.client?.city || "N/A"}
            />
            <Field
              label="District"
              value={newFormDetails?.client?.district || "N/A"}
            />
            <Field
              label="State"
              value={newFormDetails?.client?.state || "N/A"}
            />
            <Field
              label="Postal Code"
              value={newFormDetails?.client?.postalCode || "N/A"}
            />
            <Field
              label="Country"
              value={newFormDetails?.client?.country || "N/A"}
            />
          </Card>

          <Card title="Inspection Details">
            <Field
              label="Reference No."
              value={newFormDetails?.inspection?.refNumber || "N/A"}
            />
            <Field
              label="Inspection Date"
              value={<NuDate value={newFormDetails?.inspection?.date} />}
            />
            <Field
              label="Location"
              value={newFormDetails?.inspection?.location || "N/A"}
            />
            <Field
              label="Priority"
              value={newFormDetails?.inspection?.priority || "N/A"}
            />
            <Field
              label="Status"
              value={newFormDetails?.inspection?.status || "N/A"}
            />
            <Field
              label="Approval Status"
              value={newFormDetails?.inspection?.approvalStatus || "N/A"}
            />
          </Card>
        </div>

         <Card title="Inspection Summary" className="">
           <p className="text-gray-700 leading-relaxed">This is to certify that the above-referenced water-based fire protection system has been inspected in accordance with NFPA 25: Standard for the Inspection, Testing, and Maintenance of Water-Based Fire Protection Systems"</p>
           <p className="mt-3 font-semibold text-gray-900">
             <span className="font-semibold">Next Inspection Due:</span> May 15, 2024
           </p>
         </Card>
          {newFormDetails?.forms.length > 0 && (

  <Card title="Form" className="">
            <ul className="space-y-4">
              {newFormDetails?.forms.map((def, i) => (
                <li
                  key={i}
                  className="rounded-xl border p-4 shadow-sm ring-1 ring-black/5"
                >
                  <div className="flex gap-3">
                    <div className="w-1.5 shrink-0 rounded-full bg-yellow-500" />
                    <div className="space-y-1">
                      <p className="font-semibold text-gray-900">
                        {def.formName}
                      </p>
                      {/* <p className="text-gray-700">{def.description}</p> */}
                      <p className="text-gray-700">
                        <span className="font-semibold">
                          Recommended Action:
                        </span>{" "}
                        {def.comments}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          
        </Card>)}
        <div className="mt-6 w-full grid md:grid-cols-2 gap-6 py-2 px-2 mb-10">
          <SignatureBox
            label="inspector"
            refCanvas={signOne}
            formData={formData}
            setFormData={setFormData}
            isEditing={isEditing}
            onRemove={() => removeSignature("signature1")}
            toast={toastService}
            oldSignature={oldSignatures.signature1}
          />

          <SignatureBox
            label="customer"
            refCanvas={signTwo}
            formData={formData}
            setFormData={setFormData}
            isEditing={isEditing}
            onRemove={() => removeSignature("signature2")}
            toast={toastService}
            oldSignature={oldSignatures.signature2}
          />
        </div>

        <div className="flex justify-end">
          <button
            className={`${
              isSubmitting ? "bg-red-300 cursor-wait" : "bg-textColor-main"
            } px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center mr-3`}
            onClick={saveSignatures}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Save Signatures"}
          </button>
        </div>
      </div>
    </div>
  );
}


function Card({ title, children }) {
  return (
    <div className="rounded-2xl border bg-white p-5 shadow-sm ring-1 ring-black/5 my-4">
      {title ? (
        <h3 className="mb-3 text-lg font-semibold text-gray-900">{title}</h3>
      ) : null}
      <div className="space-y-2">{children}</div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div className="flex w-full justify-between">
      <p className="font-semibold text-gray-700 w-1/2">{label}</p>
      <span className="text-gray-500 w-1/2">: {value}</span>
    </div>
  );
}


function SignatureBox({
  label,
  refCanvas,
  formData,
  setFormData,
  isEditing,
  onRemove,
  toast,
  oldSignature,
}) {
  const signatureKey = `signature${label === "inspector" ? "1" : "2"}`;


  const getSignatureImageUrl = () => {
    const signatureData = formData[signatureKey];
    if (signatureData instanceof File) {
      return URL.createObjectURL(signatureData);
    }
    if (oldSignature) {
      return oldSignature; 
    }
    return null;
  };

  const signatureImageUrl = getSignatureImageUrl();

  const dataURLtoBlob = (dataURL) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleSaveSignature = () => {
    if (!isEditing) return;

    if (signatureImageUrl) {
          onRemove();
    } else if (refCanvas.current) {
      if (refCanvas.current.isEmpty()) {
        toast.open({
          type: "error",
          message: "Error",
          description: "Please provide a signature first",
        });
        return;
      }
      const dataURL = refCanvas.current.toDataURL("image/png");
      const blob = dataURLtoBlob(dataURL);
      const file = new File([blob], `${signatureKey}.png`, {
        type: "image/png",
      });

         setFormData((prev) => ({
        ...prev,
        [signatureKey]: file,
      }));

         refCanvas.current.clear();
    }
  };

  const handleResetSignature = () => {
    if (refCanvas.current) {
      refCanvas.current.clear();
    }
  };

  return (
    <div className="relative border w-full h-64 p-2 rounded-md bg-white">
      {signatureImageUrl ? (
        <img
          src={signatureImageUrl}
          alt={`${label} Signature`}
          className="border border-gray-400 w-full h-52 rounded-md object-contain"
        />
      ) : (
        <SignatureCanvas
          penColor="black"
          canvasProps={{
            className: "border border-gray-400 w-full h-52 rounded-md",
            disabled: !isEditing,
          }}
          ref={refCanvas}
        />
      )}

      <div className="flex justify-between items-center mt-1">
        <span className="text-xs font-semibold text-gray-500 capitalize">
          {label} :
        </span>
        <div className="flex gap-3">
            {!signatureImageUrl && (
            <button
              type="button"
              disabled={!isEditing}
              onClick={handleResetSignature}
              className="text-xs px-3 py-1 rounded-md font-medium bg-yellow-400 text-white"
            >
              Reset
            </button>
          )}

          <button
            type="button"
            disabled={!isEditing}
            onClick={handleSaveSignature}
            className={`text-xs px-3 py-1 rounded-md font-medium ${
              signatureImageUrl
                ? "bg-red-500 text-white"
                : "bg-gray-200 text-textColor-main"
            }`}
          >
            {signatureImageUrl ? "Remove" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}



